import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { LoginSocialBarDefinition, LoginSocialBarCSSVars } from './LoginSocialBar'

const justifyContents = {
	rtl: { left: 'flex-end', right: 'flex-start', center: 'center' },
	ltr: { left: 'flex-start', right: 'flex-end', center: 'center' },
} as const

export const css = withCompInfo<LoginSocialBarCSSVars, LoginSocialBarDefinition>()(
	// @ts-ignore - remove once siteFonts is added to CompInfo
	['compProps', 'styleProperties', 'compLayout', 'siteFonts', 'isMobileView'],
	// @ts-ignore - remove once siteFonts is added to CompInfo
	({ compProps, styleProperties, compLayout, siteFonts, isMobileView }) => {
		const { buttonsDirection, buttonsAlignment, iconSize } = compProps
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView }

		return {
			'justify-content': justifyContents[buttonsDirection]?.[buttonsAlignment] ?? 'flex-end',
			direction: buttonsDirection,
			'--icon-size': `${iconSize}px`,
			'--fnt': getScaledFont(compInfo, 'fnt'),
		}
	}
)
